import {
  WSCard,
  WSDataItem,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

import { PAYROLL_CURRENCY } from "../../constants";
import { PayrollRunsWalletBalance } from "../../selectors/selectorPayrollRunsWalletBalance";

type Props = {
  balance: PayrollRunsWalletBalance;
  onManageAccount?: () => void;
  onTopUp?: () => void;
};

export const WalletBalanceCard: React.FC<Props> = ({
  balance,
  onManageAccount,
  onTopUp
}) => (
  <WSCard
    actions={
      onTopUp
        ? {
            alignment: "fill",
            buttons: [
              { label: "Top-up wallet", kind: "Secondary", onClick: onTopUp }
            ]
          }
        : undefined
    }
    divider="bottom"
    header={{
      label: "Available balance",
      // No mask means no funding account resolved — don't render a link to a
      // masked account that isn't there.
      value: balance.accountMask
        ? {
            action: {
              label: `(•••${balance.accountMask})`,
              rightIcon: "chevron-right",
              onClick: onManageAccount
            }
          }
        : undefined
    }}
  >
    <WSText.Heading1 color="gray500" mb="XL" weight="book">
      {formatMoney(balance.availableBalance, PAYROLL_CURRENCY)}
    </WSText.Heading1>

    <WSList gap="S">
      <WSDataItem
        inline
        label="Current balance"
        value={formatMoney(balance.currentBalance, PAYROLL_CURRENCY)}
      />
      <WSDataItem
        inline
        label="Pending amounts"
        value={formatMoney(balance.pendingAmount, PAYROLL_CURRENCY)}
      />
    </WSList>
  </WSCard>
);
